import { Header, BottomNav } from "../components/Header";
import MyPurchasesContent from "../components/MyPurchasesContent";

const MyPurchasesPage = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9] pb-20 md:pb-8">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-6">
        <MyPurchasesContent />
      </main>
      <BottomNav />
    </div>
  );
};

export default MyPurchasesPage;
